/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PortfolioCategory } from './';
import {
    PortfolioCategoryFromJSON,
    PortfolioCategoryFromJSONTyped,
    PortfolioCategoryToJSON,
} from './';
import type { PortfolioPeriod } from './';
import {
    PortfolioPeriodFromJSON,
    PortfolioPeriodFromJSONTyped,
    PortfolioPeriodToJSON,
} from './';

/**
 * 
 * @export
 * @interface PortfolioItemUpdateRequest
 */
export interface PortfolioItemUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemUpdateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemUpdateRequest
     */
    description: string;
    /**
     * 
     * @type {PortfolioPeriod}
     * @memberof PortfolioItemUpdateRequest
     */
    period?: PortfolioPeriod;
    /**
     * Content blocks stored as opaque JSON (e.g. TipTap document)
     * @type {object}
     * @memberof PortfolioItemUpdateRequest
     */
    contentBlocks: object;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioItemUpdateRequest
     */
    published: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItemUpdateRequest
     */
    tags?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PortfolioItemUpdateRequest
     */
    industryExpertises?: Array<string>;
    /**
     * 
     * @type {PortfolioCategory}
     * @memberof PortfolioItemUpdateRequest
     */
    category?: PortfolioCategory;
    /**
     * 
     * @type {string}
     * @memberof PortfolioItemUpdateRequest
     */
    thumbnail?: string;
    /**
     * ID of the linked profile experience. On update, a missing or null value clears the existing link. A present value replaces it.
     * @type {string}
     * @memberof PortfolioItemUpdateRequest
     */
    experienceId?: string;
}

/**
 * Check if a given object implements the PortfolioItemUpdateRequest interface.
 */
export function instanceOfPortfolioItemUpdateRequest(value: object): value is PortfolioItemUpdateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('contentBlocks' in value) || value['contentBlocks'] === undefined) return false;
    if (!('published' in value) || value['published'] === undefined) return false;
    return true;
}

export function PortfolioItemUpdateRequestFromJSON(json: any): PortfolioItemUpdateRequest {
    return PortfolioItemUpdateRequestFromJSONTyped(json, false);
}

export function PortfolioItemUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioItemUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
        'period': json['period'] == null ? undefined : PortfolioPeriodFromJSON(json['period']),
        'contentBlocks': json['contentBlocks'],
        'published': json['published'],
        'tags': json['tags'] == null ? undefined : json['tags'],
        'industryExpertises': json['industryExpertises'] == null ? undefined : json['industryExpertises'],
        'category': json['category'] == null ? undefined : PortfolioCategoryFromJSON(json['category']),
        'thumbnail': json['thumbnail'] == null ? undefined : json['thumbnail'],
        'experienceId': json['experienceId'] == null ? undefined : json['experienceId'],
    };
}

export function PortfolioItemUpdateRequestToJSON(value?: PortfolioItemUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'title': value['title'],
        'description': value['description'],
        'period': PortfolioPeriodToJSON(value['period']),
        'contentBlocks': value['contentBlocks'],
        'published': value['published'],
        'tags': value['tags'],
        'industryExpertises': value['industryExpertises'],
        'category': PortfolioCategoryToJSON(value['category']),
        'thumbnail': value['thumbnail'],
        'experienceId': value['experienceId'],
    };
}

